var _style, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogosvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000111887246000535556290000006812010673471958438_);}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.4,
    y: 6.5,
    className: "st0",
    width: 75.1,
    height: 85.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.7569,
    y1: -104.1229,
    x2: 5.8769,
    y2: -160.6029,
    gradientTransform: "matrix(1 0 0 -1 0 -58)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D2E05C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#C6D933"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#418C41"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.9,76.3l8.6-4.9L50,82.5l29-16.6V43.6l8.5-4.9v32.1L50,92.4L21.9,76.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129928115926449015790000016534919584498225815_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.6206,
    y1: -72.6871,
    x2: -57.1194,
    y2: -125.6871,
    gradientTransform: "matrix(1 0 0 -1 0 -58)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#72CCF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#72CCF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#7459A6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129928115926449015790000016534919584498225815_)"
    },
    d: "M64,57.6l-14,8l-13.7-8V41.3L50,33.6l14,8 l23.6-13.5L50,6.6L12.4,28v42.9l16.1-9.2L50,73.9l21.4-12.3V48l-7.5,4.2L64,57.6z M20,32.2l30-17L72.5,28l-3.7,2.1l-17.2-9.8 c0.3-1-0.2-2.1-1.2-2.4c-1-0.3-2.1,0.2-2.4,1.2C48,19.3,48,19.5,48,19.7c0,0.2,0,0.5,0.1,0.7L25.6,33.2c-0.4-0.4-0.9-0.6-1.4-0.6 c-1.1,0.2-1.8,1.3-1.5,2.4c0.1,0.6,0.5,1.1,1.1,1.4v19.4L20,58L20,32.2z M28.5,53.1l-3.8,2.2V36.4c0.8-0.2,1.4-1,1.5-1.9 c0-0.2,0-0.3,0-0.5l22.5-12.9c0.3,0.3,0.8,0.4,1.2,0.4c0.5,0,1-0.2,1.3-0.5l16.7,9.6l-4,2.2l-14-7.9L28.5,37L28.5,53.1L28.5,53.1z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosvg);
export default __webpack_public_path__ + "static/media/logo svg.e579074adce53dbfeb55b3f08f743029.svg";
export { ForwardRef as ReactComponent };